var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"chevron-down",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"}},[_c('path',{attrs:{"d":"M4.6001 5.99997L8.6001 9.99997L12.6001 5.99997","stroke":"#344054","stroke-width":"1.336","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }